import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import GenericTable from "../../components/0. Tablas/CursoTable";
import ActividadesView from "../../components/1.3 actividades/Actividad";
import LoadingOverlay from "../../components/0. Utilidades/LoadingOverlay";
import { getApiUrl } from "../../utils/apiUrl";

const ActividadPage = () => {
  const { id } = useParams();
  const [selectedActividad, setSelectedActividad] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let isActive = true;

    if (id) {
      setLoadingDetail(true);
      fetch(getApiUrl(`api/perfiles/actividades/${id}/`), {
        credentials: "include",
      })
        .then((res) => {
          if (!res.ok) throw new Error("No se pudo cargar la actividad.");
          return res.json();
        })
        .then((data) => {
          if (!isActive) return;
          setSelectedActividad(data);
          setShowModal(true);
          setLoading(false);
        })
        .catch((err) => {
          if (!isActive) return;
          console.error("Error:", err);
          setLoading(false);
        })
        .finally(() => {
          if (isActive) setLoadingDetail(false);
        });
    } else {
      setSelectedActividad(null);
      setShowModal(false);
      setLoading(false);
      setLoadingDetail(false);
    }

    return () => {
      // Do not abort the HTTP response: closing an in-flight socket was causing
      // BrokenPipe errors in Django. Ignore stale results instead.
      isActive = false;
    };
  }, [id]);

  const handleActividadSelect = (actividad) => {
    setLoadingDetail(true);
    setShowModal(false);
    setSelectedActividad(null);
    navigate(`/actividades/${actividad.id}`);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedActividad(null);
    navigate("/actividades");
  };

  const columns = [
    { Header: "Nombre", accessor: "nombre" },
    { Header: "Comuna", accessor: "comuna" },
    { Header: "Oficio", accessor: "oficio" },
  ];

  if (loading) return <LoadingOverlay />;

  return (
    <>
      {(loading || loadingDetail) && <LoadingOverlay />}
      <div className="actividad-page capsule">
        <GenericTable
          apiUrl={getApiUrl("api/perfiles/tabla/actividades/")}
          columns={columns}
          onRowClick={handleActividadSelect}
          category="actividades"
        />

        {showModal && selectedActividad && (
          <Modal
            show={showModal}
            onHide={handleCloseModal}
            size="xl"
            backdrop="static"
            dialogClassName="modal-100w"
          >
            <Modal.Body className="actividad-detail-modal position-relative">
              <button
                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-3"
                onClick={handleCloseModal}
              >
                &times;
              </button>
              <ActividadesView actividad={selectedActividad} />
            </Modal.Body>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ActividadPage;
